<template>
  <div class="overflow-hidden">
    <v-app-bar
      color="#252a39"
      class="px-sm text-left shadow-sm"
      flat
      height="100"
      absolute
      prominent
    >
      <v-container class="d-flex align-center mt-2">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="black"
        />
        <v-toolbar-title class="white--text">
          <img
            src="/images/np_white_logo.png"
            alt
          >
        </v-toolbar-title>

        <v-spacer />
        <v-btn
          @click="logout"
          text
          dark
        >
          <v-icon class="mr-1">
            mdi-logout
          </v-icon>Sign Out
        </v-btn>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
  export default {
    name: 'AppBar',
    data () {
      return {
        userDrawer: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
    methods: {
      logout () {
        this.$store.dispatch('logout')
        this.$router.push({ name: 'SignIn' })
      },
    },
  }
</script>
